// extracted by mini-css-extract-plugin
export var Bounce = "index-module--Bounce--b2ee7";
export var Bouncing = "index-module--Bouncing--c0951";
export var GiftsNotification = "index-module--GiftsNotification--78dc3";